/**
 *
 * Organizations/Show/LandingPagePreferences/OrganizationOptions
 *
 */

import React from 'react'

// NPM Libraries
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import styled from '@emotion/styled'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// Components
import Checkbox from 'components/Checkbox'

const Container = styled.div`
	display: flex;
	margin-top: 10px;
	.tooltip {
		max-width: 500px;
	}
`

function OrganizationOptions({ state, mergeState }) {
	const styles = {}
	return (
		<div className="text-left mx-3 mb-3">
			<div className="mt-3">
				These options apply to all campaign types.
				<br />
				<Link to="#opt_ins">Opt-ins</Link> can be customized and set per campaign.
			</div>

			<hr className="my-3" />

			<Container style={styles}>
				<Checkbox
					label="Social Share"
					checked={state.social_share}
					onChange={(bool) => mergeState({ social_share: bool })}
				/>

				<FontAwesomeIcon
					data-tip
					data-for="social-share"
					icon="info-circle"
					size="md"
					className="text-primary ml-2 mt-1"
				/>

				<ReactTooltip id="social-share" className="unzoom tooltip" place="right" effect="float">
					<div style={{ maxWidth: '100px !important' }}>
						Social Share is an optional tool that appears after registering on the Landing Page. It provides
						buttons for the registrant to share the Event details via email or across various social media
						platforms.
					</div>
				</ReactTooltip>
			</Container>
		</div>
	)
}

OrganizationOptions.propTypes = {
	state: PropTypes.object,
	mergeState: PropTypes.func,
}

export default OrganizationOptions
